// extracted by mini-css-extract-plugin
export default {"wrapper":"Vw-z","viewport":"Ww-z","container":"Xw-z","slide":"Yw-z"};